export const toggleShowDato = () => ({
  type: 'TOGGLE_SHOW_DATO' as const
});

export type KvdHelperAction = ReturnType<typeof toggleShowDato>;
